import { createFileRoute } from '@tanstack/react-router'

import { SentrySettingsPage } from '#features/integrations/sentry/sentry-settings-page'

export const Route = createFileRoute(
  '/_app/$workspace/settings/integrations/sentry',
)({
  head: () => ({
    meta: [
      {
        title: 'Sentry integration',
      },
    ],
  }),
  component: () => <SentrySettingsPage />,
})
